import { noop } from 'lodash';
import { createContext } from 'react';

import { useGuardedContext } from '@/hooks/useGuardedContext';
import { AiOnboardingModal_AiSuggestionFragment } from '@/modules/aiOnboarding/AIOnboardingModal/graphql/aiOnboardingModal.generated';
import {
  EstateOnboardingContextSuggestion,
  EstateOnboardingSuggestionGroup,
  SuggestionsByGroup,
} from '@/modules/estate/estateAIOnboarding/estateOnboarding.types';

export interface EstateOnboardingUnacknowledgedSuggestionsContextShape {
  suggestionsToReview: EstateOnboardingContextSuggestion[];
  suggestionsToReviewByGroup: SuggestionsByGroup;
  additionalReferenceSuggestions: AiOnboardingModal_AiSuggestionFragment[];
  countsByGroup: Record<EstateOnboardingSuggestionGroup, number>;
  totalCount: number;
  loading: boolean;
  refetch: () => void;
}

const defaultGroups: EstateOnboardingUnacknowledgedSuggestionsContextShape['suggestionsToReviewByGroup'] =
  {
    [EstateOnboardingSuggestionGroup.DirectHoldings]: [],
    [EstateOnboardingSuggestionGroup.TrustEntities]: [],
    [EstateOnboardingSuggestionGroup.TrustHoldings]: [],
    [EstateOnboardingSuggestionGroup.BusinessEntities]: [],
    [EstateOnboardingSuggestionGroup.BusinessHoldings]: [],
  };

export const EstateOnboardingUnacknowledgedSuggestionsContext =
  createContext<EstateOnboardingUnacknowledgedSuggestionsContextShape>({
    suggestionsToReview: [],
    suggestionsToReviewByGroup: defaultGroups,
    additionalReferenceSuggestions: [],
    countsByGroup: {
      [EstateOnboardingSuggestionGroup.DirectHoldings]: 0,
      [EstateOnboardingSuggestionGroup.TrustEntities]: 0,
      [EstateOnboardingSuggestionGroup.TrustHoldings]: 0,
      [EstateOnboardingSuggestionGroup.BusinessEntities]: 0,
      [EstateOnboardingSuggestionGroup.BusinessHoldings]: 0,
    },
    totalCount: 0,
    loading: false,
    refetch: noop,
  });

export const useEstateOnboardingUnacknowledgedSuggestionsContext = () =>
  useGuardedContext(
    EstateOnboardingUnacknowledgedSuggestionsContext,
    'EstateOnboardingUnacknowledgedSuggestionsProvider'
  );
